module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "StatusBadge"
  }, [_c('p', {
    staticClass: "StatusBadge-label"
  }, [_vm._v("\n    Ask staff"), _c('br'), _vm._v(" for more info\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "StatusBadge-background"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e129687"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusBadge.vue
// module id = 355
// module chunks = 1